import { render, staticRenderFns } from "./Legislation.vue?vue&type=template&id=66fb7436&scoped=true&"
import script from "./Legislation.vue?vue&type=script&lang=ts&"
export * from "./Legislation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fb7436",
  null
  
)

export default component.exports